const es = {
  //siderbar file start
  Welcome: "Bienvenido",
  "Loading businesses...": "Cargando negocios...",
  "No businesses available": "No hay negocios disponibles",
  Dashboard: "Tablero",
  Menu: "Menú",
  Orders: "Pedidos",
  Offers: "Ofertas",
  "Genie Tag": "Etiqueta Genie",
  "Business Report": "Informe de Negocio",
  Photos: "Fotos",
  "Social Networks": "Redes Sociales",
  "Shop Now": "Compra Ahora",
  Profile: "Perfil",
  Logout: "Cerrar Sesión",
  "Customer Orders": "Pedidos de Clientes",
  "Business Reports": "Informes de Negocios",
  "Select Business": "Seleccionar Negocio",
  //sidebar file end
  //Login file start
  loginTitle: "Iniciar sesión",
  emailPlaceholder: "Correo electrónico",
  passwordPlaceholder: "Contraseña",
  loginButton: "Iniciar sesión",
  forgotPassword: "¿Olvidaste tu contraseña?",
  or: "O",
  resetPasswordTitle: "Restablecer contraseña",
  enterEmailLabel: "Ingresa tu correo electrónico",
  cancel: "Cancelar",
  sendResetLink: "Enviar enlace",
  resetSuccess: "Enlace enviado con éxito. Revisa tu correo.",
  resetError: "Error al enviar el enlace. Intenta de nuevo.",
  enterEmailPrompt: "Por favor, ingresa tu correo electrónico.",
  incorrectPassword: "Contraseña incorrecta. Intenta de nuevo.",
  noUserFound: "No se encontró usuario con este correo.",
  loginFailed: "Error al iniciar sesión. Intenta de nuevo.",
  "Reset Password": "Restablecer contraseña",
  //loginfile end
  //Dashboard file start
  Reviews: "Reseñas",
  Ratings: "Calificaciones",
  Scans: "Escaneos",
  Clicks: "Clics",
  "Active Offers": "Ofertas Activas",
  "No Offers available": "No hay ofertas disponibles",
  "Scans Overview": "Resumen de Escaneos",
  "Filter by": "Filtrar por",
  Reset: "Restablecer",
  Apply: "Aplicar",
  "No Scans Available": "No hay escaneos disponibles",
  "Clicks Overview": "Resumen de Clics",
  "No Clicks Available": "	No hay clics disponibles",
  "Latest Reviews": "Reseñas más recientes",
  "View All Reviews": "Ver todas las reseñas",
  "Show Less": "Mostrar menos",
  "Coupon code copied": "Código de cupón copiado",
  //Dashboard file end
  //MenuContent file start
  "Menu Management": "Gestión del Menú",
  "Add Category": "Agregar Categoría",
  "No Categories Displaying":
    "Aún no hay categorías. Haz clic en 'Agregar Categoría' para crear una y comenzar.",
  "Menu item": "Elemento del Menú",
  "No Menu Items Displaying":
    "Aún no hay elementos de menú. Haz clic en 'Agregar Elemento del Menú' para crear uno y comenzar.",
  "No items available": "No hay elementos disponibles",
  "Add New Menu Item": "Agregar Nuevo Elemento del Menú",
  "Edit Menu Item": "Editar Elemento del Menú",
  Yes: "Sí",
  No: "No",
  "Are you sure you want to delete this item?":
    "¿Estás seguro de que deseas eliminar este elemento?",
  "Add Menu Item": "Agregar Elemento del Menú",
  "Add Item": "Agregar artículo",
  Price: "Precio",
  "Item Name": "Nombre del artículo",
  //MenuContent file end
  //CategoryCreation file start
  "Select Categories": "Seleccionar categorías",
  Back: "Atrás",
  "Are you sure you want to delete": "¿Estás seguro de que deseas eliminar",
  Delete: "Eliminar",
  Cancel: "Cancelar",
  "Search Category": "Buscar categoría",
  //CategoryCreation file end
  //OrdersContent file start
  "Your Orders": "Tus pedidos",
  "Order ID": "ID del pedido",
  Date: "Fecha",
  "Product Name": "Nombre del producto",
  Amount: "Monto",
  "View Genie Tags": "Ver etiquetas Genie",
  "Your Genie Tags": "Tus etiquetas Genie",
  Business: "Negocio",
  Status: "Estado",
  "No Genie Tags available.": "No hay etiquetas Genie disponibles.",
  "No orders found.": "No se encontraron pedidos.",
  "Transaction ID": "ID de transacción",
  //OrdersContent file end
  //Customer Orders file Start
  "Create Order": "Crear pedido",
  "Customer Details": "	Detalles del cliente",
  "Business Name": "Nombre del negocio",
  "Transaction Details": "Detalles de la transacción",
  "Assign Genie Tags": "Asignar etiquetas Genie",
  Submit: "Enviar",
  //Customer Orders file end
  //plates Content file start
  "Genie Tags": "Etiquetas Genie",
  Code: "Código",
  "No Data Available": "No hay datos disponibles",
  //plates Content file end
  //Customer Plates  file start
  Actions: "Acciones",
  "Add Review": "Añadir reseña",
  "Add Review Count": "Agregar conteo de reseñas",
  "View Clicks": "Ver clics",
  "Add Menu": "Agregar menú",
  Graphs: "Gráficas",
  "Business Networks": "Redes de negocios",
  "usiness Photos": "Fotos del negocio",
  "Business Graphs": "Gráficas del negocio",
  "Business Menu": "Menú de negocios",
  //Customer Plates  file end
  //Offers file start
  "Inactive Offers": "Ofertas inactivas",
  "Expired Offers": "Ofertas vencidas",
  "Create New Offer": "Crear nueva oferta",
  "Add Offer": "Agregar oferta",
  "Delete Offer": "Eliminar oferta",
  "Edit Offer": "Editar oferta",
  Update: "Actualizar",
  "Expiration Date": "Fecha de vencimiento",
  "Coupon Code": "Código de cupón",
  Description: "Descripción",
  "Offer Title": "Título de la oferta",
  "Are you sure you want to delete this offer?":
    "¿Estás seguro de que quieres eliminar esta oferta?",
  Save: "Guardar",
  "No Expired Offers Available": "No hay ofertas vencidas disponibles",
  "Code copied successfully!": "¡Código copiado con éxito!",
  "No Inactive Offers Available": "No hay ofertas inactivas disponibles",
  "No Offers Available": "No hay ofertas disponibles",
  //Offers files end
  //Gallery file start
  Photostitle: "Fotos",
  "No Images Available":
    "Aún no hay imágenes,Haz clic en 'Subir imágenes' y comienza!",
  "Upload Image": "	Subir imagen",
  "Upload Images": "Subir imágenes",
  "Delete Image": "Eliminar imagen",
  "Are you sure you want to delete this image?":
    "¿Estás seguro de que quieres eliminar esta imagen?",
  "Uploading...": "Subiendo...",
  Upload: "Subir",
  //Gallery file end
  //Profile file  start
  "Update Profile": "Actualizar perfil",
  "Change Password": "Cambiar contraseña",
  "Update Password": "Actualizar contraseña",
  //Profile file  end
  //userbusinessreports file  start
  "Created Date": "Fecha de creación",
  Networks: "Redes",
  "Filter Reports by": "Filtrar informes por",
  //userbusinessreports file  end
  //manualordercreation file  start
  "Shipping Cost": "Costo de envío",
  "Product Price": "Precio del producto",
  "Order Details": "Detalles del pedido",
  "Creating Order...": "Creando pedido...",
  "Use billing address as Shipping address":
    "Usar dirección de facturación como dirección de envío",
  "Payment Details": "Detalles de pago",
  "Delivery Address": "Dirección de entrega",
  Phone: "Teléfono",
  Email: "Correo electrónico",
  "Select Products": "Seleccionar productos",
  "Business Information": "Información del negocio",
  "Can't find your business? No worries.Enter your business name,":
    "¿No encuentras tu negocio? No te preocupes.Ingresa el nombre,",
  "city and postal code.": "ciudad y código postal.",
  "Search for your business to get set up":
    "Busca tu negocio para configurarlo",
  "Manual Order Creation": "Creación manual de pedido",
  "Billing Address": "Dirección de facturación",
  //manualordercreation file  end
  //Reviewprovider file start
  "Explore Our Socials and Share Your Feedback! Your Opinions Matter to Us!":
    "¡Explora nuestras redes sociales y comparte tu opinión! ¡Tu opinión es importante para nosotros!",
  "Add a description to your All-In-One Plate to provide more information about your business. This will be visible on your page.":
    "Agrega una descripción a tu All-In-One Plate para proporcionar más información sobre tu negocio. Esto será visible en tu página.",
  "Provider Name": "Nombre del proveedor",
  "Provider URL": "URL del proveedor",
  "WhatsApp Number": "Número de WhatsApp",
  //Reviewprovider file end

  //customer pages
  //landingpage file start
  Website: "Sitio web",
  "Check Menu": "Ver menú",
  "Leave us a Google Review": "Déjanos una reseña en Google",
  "Connect With Us and Share Your Feedback Your Opinion Matter to Us!":
    "¡Conéctate con nosotros y comparte tu opinión! ¡Tu opinión es importante para nosotros!",
  "Show Less...": "	Mostrar menos...",
  "View More...": "	Ver más...",
  "Connect With Us": "Conéctate con nosotros",
  Share: "Compartir",
  Expires: "Expira",
  "More details..": "Más detalles..",
  //landingpage file end
  //menu page file start
  "Connect With Us Share Your Feedback. Your Opinion Matters to Us!":
    "Contáctanos Comparte tu opinión. ¡Tu opinión es importante para nosotros!",
  "No Items Available": "No hay artículos disponibles",
  //menu page file end
  //socialmediareview file start
  "Drag and drop the icon to change the order of appearance on your All-In-One Page.":
    "Arrastra y suelta el ícono para cambiar el orden de aparición en tu página All-In-One.",
  Continue: "Continuar",
  //socialmediareview file end
  //plates file start
  "Please help us validate your business below":
    "Por favor, ayúdanos a validar tu negocio a continuación",
  "Powered by": "Desarrollado por",
  "Choose a category": "Elige una categoría",
  Bars: "Bares",
  Lounge: "Lounge",
  "Beauty salon's": "Salones de belleza",
  Barbershop: "Barbería",
  Restaurant: "Restaurante",
  "Genie tag": "Etiqueta Genie",
  Validate: "Validar",
  //plates file end

  //signup file start
  "Sign Up": "Registrarse",
  "To start setting up your new plate":
    "Para comenzar a configurar tu nuevo perfil/plate",
  "Already have an account?": "¿Ya tienes una cuenta?",
  "Sign In": "Iniciar sesión",
  //signup file end
  //Home pages start
  //layoutdesign file
  Features: "Características",
  "How to Setup": "Cómo Configurar",
  "Our App": "Nuestra App",
  "Seamless Check-Ins": "Registros Sin Complicaciones",
  "PointGenie makes customer reviews seamless with NFC technology. No apps, no hassle—just tap and leave a review in seconds. Increase your visibility on Google and gain customer trust effortlessly!":
    "PointGenie facilita las reseñas de clientes con tecnología NFC. Sin apps, sin complicaciones: solo toca y deja una reseña en segundos. ¡Aumenta tu visibilidad en Google y gana la confianza de tus clientes fácilmente!",
  "Get Started Now!": "¡Comienza Ahora!",
  "Your customers will leave you": "Tus clientes te dejarán",
  "a Review in Only 3 Seconds!": "¡Una reseña en solo 3 segundos!",
  "Instant Google Review Access": "Acceso Instantáneo a Reseñas de Google",
  "Boost Your Online Presence in Seconds with just a tap, customers are instantly directed to your Google review page — no hassle, no delays. Watch your ratings soar!":
    "Impulsa tu presencia en línea en segundos: con solo un toque, los clientes son dirigidos instantáneamente a tu página de reseñas de Google — sin complicaciones, sin demoras. ¡Mira cómo suben tus calificaciones!",
  "Seamless Social Media Integration": "Integración Fluida con Redes Sociales",
  "Turn Visitors into Followers Get more likes, shares, and loyal fans. Customers can follow your social media profiles instantly with a simple tap.":
    "Convierte a los visitantes en seguidores Obtén más Me gusta, compartidos y seguidores leales. Los clientes pueden seguir tus perfiles en redes sociales al instante con solo un toque",
  "Get more likes, shares, and loyal fans. Customers can follow your social media profiles instantly with a simple tap.":
    "Consigue más 'me gusta', compartidos y seguidores fieles. Los clientes pueden seguir tus perfiles sociales al instante con solo un toque.",
  "Touchless Digital Menu Access": "Acceso al Menú Digital Sin Contacto",
  "Your Menu, Instantly in Their Hands Forget printed menus — showcase your latest specials, offers, and updates digitally with a seamless NFC experience.":
    "Tu Menú, Instantáneamente en Sus Manos Olvídate de los menús impresos — muestra tus últimas ofertas, promociones y novedades digitalmente con una experiencia NFC sin interrupciones.",
  "Door Traffic Analytics": "Analítica de Tráfico en Puertas",
  "Understand Your Customer Flow Track foot traffic patterns in real-time. Gain insights into peak hours, customer behavior, and more to optimize staffing and operations.":
    "Comprende el Flujo de Clientes Rastrea los patrones de tráfico en tiempo real. Obtén información sobre horas pico, comportamiento del cliente y más para optimizar el personal y las operaciones.",
  "As seen on": "Visto en",
  "Find the Perfect Spot to Display Your Genie Tag!":
    "¡Encuentra el Lugar Perfecto para Colocar tu Etiqueta Genie!",
  //sectionhome file
  "How to Setup your Product": "Cómo Configurar tu Producto",
  "Boost Your Google Reviews in Just 10 Seconds- Delight Your Customers Effortlessly!":
    "Aumenta tus Reseñas de Google en Solo 10 Segundos — ¡Sorprende a tus Clientes sin Esfuerzo!",
  title: "Cómo configurar tu producto",
  subtitle:
    "Impulsa tus reseñas de Google en solo 10 segundos - ¡Sorprende a tus clientes sin esfuerzo!",
  steps: [
    {
      step: "Paso 1",
      title: "Escanea el código QR",
      description: "Cuando recibas tu placa, escanea el código QR.",
    },
    {
      step: "Paso 2",
      title: "Activa tu tarjeta",
      description:
        "Llegarás a la aplicación PointGenie: Ingresa el código de activación de tu placa y actívala.",
    },
    {
      step: "Paso 3",
      title: "¡Todo listo!",
      description:
        "¡Y eso es todo! ¡Ya estás listo para recibir tus primeras reseñas!",
    },
  ],
  //sectionthree file

  "Turn Customers into Fans with Genie Tag":
    "Convierte a tus Clientes en Fans con Genie Tag",
  "Get more Google reviews, boost engagement, and showcase your menu — all in seconds.":
    "Obtén más reseñas en Google, aumenta la interacción y muestra tu menú — todo en segundos.",
  "Instant Review Boost – Customers scan, tap, and leave a review in 3 seconds":
    "Impulso Instantáneo de Reseñas – Los clientes escanean, tocan y dejan una reseña en 3 segundos",
  "Highlight Your Best – Show off your menu, daily specials, and services":
    "Destaca lo Mejor – Muestra tu menú, especiales del día y servicios",
  "Plug-and-Play Setup – No app installs. Works right out of the box":
    "Configuración Plug-and-Play – Sin necesidad de instalar apps. Funciona directamente al sacarlo de la caja",
  "Increase Visibility – More reviews = higher ranking on Google":
    "Aumenta la Visibilidad – Más reseñas = mejor posicionamiento en Google",
  "Can't find your business?No worries. Enter your business name,":
    "¿No encuentras tu negocio?No te preocupes. Ingresa el nombre de tu negocio,",
  "BUNDLE & Save": "AHORRA con Paquetes",
  "Buy Now": "Compra Ahora",
  "30-Day Risk-Free trial": "Prueba sin Riesgo de 30 Días",
  "Free Shipping": "Envío Gratis",
  "Easy & Free Return": "Devolución Fácil y Gratuita",
  //section five
  "Frequently Asked Questions": "Preguntas Frecuentes",
  "Do I need a Google My Business local listing?":
    "¿Necesito una ficha de Google My Business?",
  "Yes, your business must have a Google My Business listing to receive Google reviews. If you don’t have one, our team can help you create it.":
    "Sí, tu negocio debe tener una ficha en Google My Business para recibir reseñas. Si no tienes una, nuestro equipo puede ayudarte a crearla.",
  "Do my customers need a Google account to write a review?":
    "¿Mis clientes necesitan una cuenta de Google para escribir una reseña?",
  "Yes, customers must have a Google account to leave a review. However, most smartphone users already have one through YouTube, Gmail, or Google Maps—93% of smartphone owners, in fact.":
    "Sí, los clientes deben tener una cuenta de Google para dejar una reseña. Sin embargo, la mayoría de los usuarios de smartphones ya tienen una a través de YouTube, Gmail o Google Maps—el 93% de los propietarios de smartphones, de hecho.",
  "Are the NFC plates compatible with all smartphones?":
    "¿Las placas NFC son compatibles con todos los smartphones?",
  "Yes! 90% of smartphones have built-in NFC technology, and 100% of smartphones can scan QR codes, making it easy for all customers to interact.":
    "¡Sí! El 90% de los smartphones tienen tecnología NFC incorporada y el 100% puede escanear códigos QR, lo que facilita la interacción para todos los clientes.",
  "How does contactless technology work?":
    "¿Cómo funciona la tecnología sin contacto?",
  "Our plates use NFC (Near Field Communication), the same technology that powers contactless payments. When customers tap or scan, a link to your business review page instantly opens—no app downloads needed. Our chip only transmits a link and does not collect any personal information.":
    "Nuestras placas usan NFC (Near Field Communication), la misma tecnología de los pagos sin contacto. Cuando los clientes tocan o escanean, se abre instantáneamente un enlace a tu página de reseñas. Nuestro chip solo transmite el enlace y no recopila información personal.",
  "Where do you ship, and how long does delivery take?":
    "¿Dónde envían y cuánto tarda la entrega?",
  "We currently only ship within the United States. Orders are processed within 1-2 business days, and delivery typically takes 4-7 business days.":
    "Actualmente solo realizamos envíos dentro de Estados Unidos. Los pedidos se procesan en 1-2 días hábiles y la entrega suele tardar entre 4 y 7 días hábiles.",
  "Do I need an app or subscription to use PointGenie NFC tags?":
    "¿Necesito una app o suscripción para usar las etiquetas NFC de PointGenie?",
  "No app or subscription is required! Our NFC plates work instantly by directing customers to Our proprietary Landing page from where they go to your Google review page when they tap or scan the tag.":
    "¡No se requiere app ni suscripción! Nuestras placas NFC funcionan al instante dirigiendo a los clientes a nuestra página de aterrizaje, desde donde acceden a tu página de reseñas de Google.",
  "How do I install my NFC plate?": "¿Cómo instalo mi placa NFC?",
  "Our plates are designed for easy installation. Simply peel and stick to a flat, clean surface like your front desk, tables, or checkout counter. For best results, place them in high-visibility areas.":
    "Nuestras placas están diseñadas para una instalación fácil. Solo retira el adhesivo y pégalas sobre una superficie plana y limpia como tu mostrador, mesas o caja. Para mejores resultados, colócalas en lugares de alta visibilidad.",
  "Can I customize the NFC plate with my logo or branding?":
    "¿Puedo personalizar la placa NFC con mi logo o marca?",
  "On Request! We offer custom branding options to match your business identity. Contact us for details on personalized designs At support@pointgenie.com.":
    "¡A pedido! Ofrecemos opciones de personalización para que coincidan con la identidad de tu negocio. Contáctanos para más detalles en support@pointgenie.com.",
  "Can I update the link on my NFC plate?":
    "¿Puedo actualizar el enlace en mi placa NFC?",
  "Our standard NFC plates are pre-programmed to link to your proprietary landing page from where they can go to google on one tap. However,With the purchase of your tag you get access to your business dashboard from where you can add more links and take advantage of other features like Digital Menus and Specials.":
    "Nuestras placas NFC estándar están programadas para vincularse a tu página de aterrizaje. Desde ahí, pueden ir a Google con un solo toque. Además, con tu compra obtienes acceso a tu panel de control donde puedes añadir más enlaces y aprovechar funciones como menús digitales y promociones.",
  "Do you offer bulk pricing for large orders?":
    "¿Ofrecen precios por volumen para pedidos grandes?",
  "Yes! If you need multiple NFC plates, we offer discounted bulk pricing. Contact us for a custom quote based on your order size at Support@pointgenie.com.":
    "¡Sí! Si necesitas varias placas NFC, ofrecemos descuentos por volumen. Contáctanos para una cotización personalizada en Support@pointgenie.com.",
  "What is your return policy?": "¿Cuál es su política de devoluciones?",
  "We stand by the quality of our NFC plates! If you receive a damaged or defective product, you can request a replacement or refund within 30 days of delivery. Simply contact our support team with your order details.":
    "¡Respaldamos la calidad de nuestras placas NFC! Si recibes un producto dañado o defectuoso, puedes solicitar un reemplazo o reembolso dentro de los 30 días posteriores a la entrega. Solo contacta a nuestro equipo de soporte con los detalles de tu pedido.",
  "What if I have more questions or need support?":
    "¿Qué hago si tengo más preguntas o necesito ayuda?",
  "We’re happy to help! Contact our support team anytime, and we’ll assist you with any questions or concerns please reach out to our Whatsapp Number 305-497-5941 or write to support@pointgenie.com.":
    "¡Con gusto te ayudamos! Contacta a nuestro equipo de soporte en cualquier momento y te asistiremos con cualquier duda. Escríbenos al número de WhatsApp 305-497-5941 o al correo support@pointgenie.com.",
  //reviews file
  "Why More Business Owners are": "Por qué cada día más dueños de negocios",
  "Choosing us Every Day": "Nos eligen todos los días",
  "David Diaz": "David Diaz",
  "CorpoBello Spa": "CorpoBello Spa",
  "Puerto Rico US": "Puerto Rico, EE. UU.",
  "PointGenie has been a game-changer for my spa. Customers love checking in and leaving reviews, and we’ve seen a noticeable increase in new clients thanks to the positive feedback. It’s easy to use, and I love how simple it is to manage everything from one place!":
    "PointGenie ha sido un cambio total para mi spa. A los clientes les encanta registrarse y dejar reseñas, y hemos visto un aumento notable en nuevos clientes gracias a los comentarios positivos. Es fácil de usar, ¡y me encanta lo simple que es manejar todo desde un solo lugar!",
  "Ariel Perez": "Ariel Perez",
  "MostWanted Cuts": "MostWanted Cuts",
  "Newark, NJ US": "Newark, Nueva Jersey, EE. UU.",
  "Honestly, I wasn’t sure if PointGenie would make a big difference, but wow — it’s been amazing. Our clients check in, leave reviews, and even follow us on social media right from the tag. It’s helped us build a solid online presence without much extra effort.":
    "Sinceramente, no estaba seguro de que PointGenie hiciera una gran diferencia, pero ¡wow! — ha sido increíble. Nuestros clientes se registran, dejan reseñas e incluso nos siguen en redes sociales directamente desde la etiqueta. Nos ha ayudado a construir una presencia en línea sólida sin mucho esfuerzo adicional.",
  "Lucy Lopez": "Lucy Lopez",
  "GetBeautyPro Studio": "GetBeautyPro Studio",
  "PointGenie makes it so easy for my clients to leave reviews right after their appointment. Since adding the tag, my Google reviews have doubled, and new clients say they found me because of all the great feedback. It’s been a huge win for my business!":
    "PointGenie hace que sea muy fácil para mis clientes dejar reseñas justo después de su cita. Desde que añadí la etiqueta, mis reseñas en Google se han duplicado, y los nuevos clientes dicen que me encontraron gracias a los buenos comentarios. ¡Ha sido un gran acierto para mi negocio!",
  "24/7/365 Live Support": "Soporte en vivo 24/7/365",
  "100% Secure Payment": "Pago 100% Seguro",
  //home pages end
  //footer file start
  "Be part of our community": "Sé parte de nuestra comunidad",
  Company: "Compañía",
  Blog: "Blog",
  "About Us": "Sobre Nosotros",
  "Contact Us": "Contáctanos",
  "Affilate With Us": "Afíliate con Nosotros",
  Legal: "Legal",
  "Press Release": "Comunicado de Prensa",
  "Terms and Condition": "Términos y Condiciones",
  "Privacy Policy": "Política de Privacidad",
  "Quick Links": "Enlaces Rápidos",
  Login: "Iniciar Sesión",
  "Copyright© 2025 Pointgenie LLC. All rights reserved.":
    "Copyright© 2025 Pointgenie LLC. Todos los derechos reservados.",
  "Handcrafted in Florida, USA": "Hecho a mano en Florida, EE. UU.",
  //footer file end
  //checkout file start
  "Express checkout": "Pago exprés",
  "Email or Phone": "Correo electrónico o Teléfono",
  "Secure Checkout": "Pago Seguro",
  "Credit Card": "Tarjeta de Crédito",
  "Your info will be saved to a shop account. By continuing, you agree to shop's":
    "Tu información se guardará en una cuenta de la tienda. Al continuar, aceptas los",
  "Terms of service": "Términos del servicio",
  "and acknowledge the": "y reconoces la",
  PrivacyPolicy: "Política de Privacidad",
  "Genie Plate": "Placa Genie",
  "Sub total": "Subtotal",
  Shipping: "Envío",
  Total: "Total",
  "Complete Purchase": "Finalizar compra",
  "processing...": "procesando...",
  //checkout file end
  //Thankyou file start
  "Thank You for Your Purchase!": "¡Gracias por tu compra!",
  "Your order has been successfully placed. We appreciate your business!":
    "¡Tu pedido ha sido realizado con éxito. ¡Agradecemos tu preferencia!",
  "Back to Home": "Volver al inicio",
  "Ooops, The page not found": "¡Ups, página no encontrada!",
  //Thankyou file end
  //profile page form 
  "Full Name":"Nombre completo",
  "Date of Birth":"Fecha de nacimiento",
  "Old Password":"Contraseña anterior",
  "New Password":"Nueva contraseña",
  "Confirm New Password":"Confirmar nueva contraseña",
  "searchAddress": "Buscar una dirección",
  "firstName": "Nombre",
  "lastName": "Apellido",
  "city": "Ciudad",
  "address": "Dirección",
  "zipCode": "Código postal",
  "enterTransactionId": "Ingrese el ID de la transacción"
};
export default es;
